import React, { useState, useEffect } from "react";

// import Table from "react-bootstrap/Table";
import "./Simpal.css";
import { connect } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Pagination } from "@mui/material";
import PropTypes from "prop-types";
import {
  applyProperty,
  getPropertyDetail,
  hiddenProperty,
  likeProperty,
  unlikeProperty,
} from "../../actions/propertyAction";

import _ from "lodash";
import {
  Fix_value,
  settings,
  silderData,
  home_appliances,
  restrictions_val,
  images,
} from "../Property-info4/propertyArray";

import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { BsFillCameraFill } from "react-icons/bs";
import { FaDog, FaSmoking, FaKorvue, FaRegBuilding } from "react-icons/fa";

import { FcCheckmark } from "react-icons/fc";

import { GiSofa, GiHomeGarage } from "react-icons/gi";
import { ImCross } from "react-icons/im";
import {
  AiOutlineEyeInvisible,
  AiOutlineHeart,
  AiFillWechat,
  AiFillHeart,
} from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { BsQuestion } from "react-icons/bs";
import { IoLocationSharp } from "react-icons/io5";
import { getActivePropertyList } from "../../actions/propertyAction";
import { loadUser } from "../../actions/authActions";
import moment from "moment";
import { Link, Redirect, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import { useSelector } from "react-redux";
let rowsPerPage = 12;

const SampleNewTable = ({
  allData,
  properties,
  getActivePropertyList,
  getPropertyDetail,
  auth,
  applyProperty,
  hiddenProperty,
  likeProperty,
  unlikeProperty,
  page,
  changePage,
  filterLoading,
  label,
}) => {
  const history = useHistory();
  const isAuth = auth.isAuthenticated;
  const userName = auth.user;
  const { frontLabelsName } = label;
  const [hasMore, setHasMore] = useState(true);
  const { getActiveAllProperty, propertyLoading } = useSelector(
    (state) => state.properties
  );

  // const { getActiveAllProperty, propertyLoading } = properties;

  useEffect(() => {
    getActivePropertyList();
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#f5d792",
        darker: "#053e85",
      },
      neutral: {
        main: "#64748B",
        contrastText: "#fff",
      },
    },
  });

  const loginCheck = async (e, id) => {
    e.preventDefault();
    if (auth.isAuthenticated) {
      const data = {
        property: id,
      };
      const res = await applyProperty(data);
    } else {
      toast.error(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_please_login_to_access")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_please_login_to_access"
              )[0]["value"] || "lbl_please_login_to_access"
            : "lbl_please_login_to_access"
          : "lbl_please_login_to_access"
      );
    }
  };

  return (
    <>
      {!propertyLoading && !filterLoading && (
        <div className="px-3 tableStyle">
          <div className="table-style-custom w-100">
            <Table className="table mt-4" responsive striped>
              <thead>
                <tr>
                  <th>
                    <img
                      src="assets/table_icons/Icon material-camera-alt.svg"
                      width="15"
                      height="15"
                    />
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_registered")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_registered"
                          )[0]["value"] || "lbl_registered"
                        : "lbl_registered"
                      : "lbl_registered"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_herb").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_herb")[0][
                            "value"
                          ] || "lbl_herb"
                        : "lbl_herb"
                      : "lbl_herb"}
                  </th>
                  <th>
                    m<sup>2</sup>
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_rent").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_rent")[0][
                            "value"
                          ] || "lbl_rent"
                        : "lbl_rent"
                      : "lbl_rent"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_pnr").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_pnr")[0][
                            "value"
                          ] || "lbl_pnr"
                        : "lbl_pnr"
                      : "lbl_pnr"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_address")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_address")[0][
                            "value"
                          ] || "lbl_address"
                        : "lbl_address"
                      : "lbl_address"}
                  </th>

                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_type").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_type")[0][
                            "value"
                          ] || "lbl_type"
                        : "lbl_type"
                      : "lbl_type"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_delivery")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_delivery")[0][
                            "value"
                          ] || "lbl_delivery"
                        : "lbl_delivery"
                      : "lbl_delivery"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_rented_to")
                          .length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_rented_to")[0][
                            "value"
                          ] || "lbl_rented_to"
                        : "lbl_rented_to"
                      : "lbl_rented_to"}
                  </th>
                  <th>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_sk").length > 0
                        ? frontLabelsName.filter((e) => e.key == "lbl_sk")[0][
                            "value"
                          ] || "lbl_sk"
                        : "lbl_sk"
                      : "lbl_sk"}
                  </th>
                  <th>
                    <img
                      src="assets/table_icons/Icon awesome-dog.svg"
                      width="15"
                      height="15"
                    />
                  </th>

                  <th>
                    <img
                      src="assets/table_icons/furniture-14-svgrepo-com.svg"
                      width="15"
                      height="15"
                    />
                  </th>

                  <th>
                    <img
                      src="assets/table_icons/Icon awesome-smoking.svg"
                      width="15"
                      height="15"
                    />
                  </th>
                  <th>
                    <img
                      src="assets/table_icons/garage.svg"
                      width="15"
                      height="15"
                    />
                  </th>
                  <th>
                    <img
                      src="assets/table_icons/K.svg"
                      width="15"
                      height="15"
                    />
                  </th>

                  <th>
                    <img
                      src="assets/table_icons/Icon material-location-on.svg"
                      width="15"
                      height="15"
                    />
                  </th>
                  {/* <th>
                    <img
                      src="assets/table_icons/Icon zocial-email.svg"
                      width="15"
                      height="15"
                    />
                  </th>
                  <th>
                    <img
                      src="assets/table_icons/Group 13974.svg"
                      width="15"
                      height="15"
                    />
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {!propertyLoading &&
                  getActiveAllProperty.length > 0 &&
                  getActiveAllProperty.map((obj, indx) => {
                    // please dont change code becoz we are mange.
                    let right = _.differenceBy(Fix_value, obj?.included);
                    let righthomeapp = _.differenceBy(
                      home_appliances,
                      obj?.homeAppliances
                    );

                    let rightrestrictions = _.differenceBy(
                      restrictions_val,
                      obj?.restrictions
                    );

                    return (
                      <tr>
                        <td>{obj?.photo_gallery.length}</td>
                        <td>{moment(obj?.createdAt).format("l")}</td>
                        <td>
                          {" "}
                          {obj?.bhk === "Storage"
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_storage")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_storage"
                                  )[0]["value"] || "lbl_storage"
                                : "lbl_storage"
                              : "lbl_storage"
                            : ""}
                          {obj?.bhk === "Single Room"
                            ? frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_single_room"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_single_room"
                                  )[0]["value"] || "lbl_single_room"
                                : "lbl_single_room"
                              : "lbl_single_room"
                            : ""}
                          {obj?.bhk === "Studio"
                            ? frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_studio")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_studio"
                                  )[0]["value"] || "lbl_studio"
                                : "lbl_studio"
                              : "lbl_studio"
                            : ""}
                          {obj?.bhk !== "Studio" &&
                          obj?.bhk !== "Single Room" &&
                          obj?.bhk !== "Storage"
                            ? obj?.bhk
                            : ""}
                        </td>
                        <td>{obj?.size}</td>
                        <td>{obj?.propertyPrice}</td>
                        <td>{obj?.area}</td>
                        <td>{obj?.location}</td>
                        <td>{obj?.propertyType}</td>
                        <td>{moment(obj?.deliveryDate).format("l")}</td>
                        <td>
                          {obj?.availabilityType === "longTerm"
                            ? "Long Term"
                            : obj?.availabilityType === "shortTerm"
                            ? "Short Term"
                            : "Available Now"}
                        </td>
                        <td>39</td>
                        <td>
                          {rightrestrictions?.includes("Pets") ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>
                        <td>
                          {right?.includes("Furniture") ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>
                        <td>
                          {rightrestrictions?.includes("Smoking") ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>
                        <td>
                          {right?.includes("Garage") ? (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                              width="15"
                              height="15"
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Icon feather-check.svg"
                              width="15"
                              height="15"
                            />
                          )}
                        </td>

                        <td>
                          <span style={{ fontSize: 18, fontWeight: "bold" }}>
                            K
                          </span>
                        </td>
                        {/* <td>
                          <img
                            src="assets/table_icons/innar-icons/Favourite (1).svg"
                            width="15"
                            height="15"
                            onClick={(e) => hidden(e, obj?._id)}
                            style={{ cursor: "pointer" }}
                          />
                        </td> */}

                        <td>
                          {/* <Link to="/properties-map"> */}
                          <IoLocationSharp
                            style={{
                              width: "20px !important",
                              height: "20px !important",
                              color: "black",
                            }}
                          />
                          {/* </Link> */}
                        </td>
                        {/* <td>
                            <img
                              src="assets/table_icons/innar-icons/Icon zocial-email.svg"
                              width="15"
                              height="15"
                            />
                       
                        </td> */}

                        {/* <td>
                          {obj?.applied === 0 ? (
                            <img
                              src="assets/table_icons/innar-icons/Group 13975.svg"
                              width="15"
                              height="15"
                              onClick={(e) => loginCheck(e, obj?._id)}
                            //   style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <img
                              src="assets/table_icons/innar-icons/Group 13975.svg"
                              width="15"
                              height="15"
                              className="disable-links"
                            //   style={{ cursor: "pointer" }}
                            />
                          )}
                        </td> */}
                      </tr>
                    );
                  })}
              </tbody>
            </Table>

            <div className="d-flex set-align pt-2">
              <Box display="flex" justifyContent="center" alignItems="center">
                <ThemeProvider theme={theme}>
                  {/* {!propertyLoading && (
                    <Pagination
                      count={property.totalPages}
                      color="primary"
                      page={page}
                      onChange={handleChange}
                      shape="rounded"
                      sx={{ textAlign: "center" }}
                    />
                  )} */}
                </ThemeProvider>
              </Box>

              <div className="right-corner-status">
                <div className="d-flex cu-position-set">
                  <div className="set-flex" style={{height:"58px"}}>
                    <span className="ml-3">
                      <img
                        src="assets/table_icons/innar-icons/Icon feather-check.svg"
                        width="15"
                        height="15"
                        className="gap-set"
                      />

                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_yes_included")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_yes_included"
                            )[0]["value"] || "lbl_yes_included"
                          : "lbl_yes_included"
                        : "lbl_yes_included"}
                    </span>
                  </div>
                  <div className="set-flex" style={{height:"58px"}}>
                    <span>
                      <img
                        src="assets/table_icons/innar-icons/Icon feather-plus.svg"
                        width="15"
                        height="15"
                        className="gap-set"
                      />

                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_no_not_included"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_no_not_included"
                            )[0]["value"] || "lbl_no_not_included"
                          : "lbl_no_not_included"
                        : "lbl_no_not_included"}
                    </span>
                  </div>
                  <div className="set-flex" style={{height:"58px"}}>
                    <span>
                      <img
                        src="assets/table_icons/innar-icons/Icon awesome-question.svg"
                        width="15"
                        height="15"
                        className="gap-set"
                      />
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_agreement")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_agreement"
                            )[0]["value"] || "lbl_agreement"
                          : "lbl_agreement"
                        : "lbl_agreement"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {propertyLoading && <Loading />}

      {filterLoading && <Loading />}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  getActivePropertyList,
  getPropertyDetail,
  loadUser,
  applyProperty,
  hiddenProperty,
  likeProperty,
  unlikeProperty,
})(SampleNewTable);

// SampleNewTable
